import script from "./evaluation.vue?vue&type=script&setup=true&lang=ts"
export * from "./evaluation.vue?vue&type=script&setup=true&lang=ts"

import "./evaluation.vue?vue&type=style&index=0&id=d556bcbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d556bcbe"]])

export default __exports__